// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"letters-p"},"nodeName":"g","children":[{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M8 12.5V5H15C15.5523 5 16 5.44772 16 6V11.5C16 12.0523 15.5523 12.5 15 12.5H8ZM8 12.5V19","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-letters-p')
export default class LettersPIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'letters-p',
    }
  }
}
